const TableSkeleton = ({ columns = 6, rows = 5 }: { columns?: number; rows?: number }) => {
  const skeletonRows = Array.from({ length: rows });
  const skeletonColumns = Array.from({ length: columns });

  return (
    <div className="table-responsive">
      <table className="table mb-0" style={{ minWidth: "860px" }}>
        <thead style={{ borderBottom: "2px solid #e5e7eb" }}>
          <tr>
            {skeletonColumns.map((_, idx) => (
              <th
                key={idx}
                className="px-4 py-3 font-onest fw-600 fs-13"
                style={{ color: "#374151", background: "#fff" }}
              >
                <div
                  style={{
                    width: "80px",
                    height: "16px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {skeletonRows.map((_, rowIdx) => (
            <tr
              key={rowIdx}
              style={{
                borderTop: rowIdx === 0 ? "none" : "1px solid #f3f4f6",
                background: "#fff",
              }}
            >
              {skeletonColumns.map((_, colIdx) => (
                <td key={colIdx} className="px-4 py-4">
                  <div
                    style={{
                      width: colIdx === 1 ? "150px" : "100px",
                      height: "16px",
                      backgroundColor: "#e5e7eb",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                      animationDelay: `${rowIdx * 0.1 + colIdx * 0.05}s`,
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {/* Pagination skeleton */}
      <div className="d-flex justify-content-end px-4 py-3">
        <div className="d-flex align-items-center gap-2">
          <div
            style={{
              width: "80px",
              height: "40px",
              backgroundColor: "#e5e7eb",
              borderRadius: "8px",
              animation: "pulse 1.5s ease-in-out infinite",
            }}
          />
          <div
            style={{
              width: "40px",
              height: "40px",
              backgroundColor: "#e5e7eb",
              borderRadius: "8px",
              animation: "pulse 1.5s ease-in-out infinite",
              animationDelay: "0.1s",
            }}
          />
          <div
            style={{
              width: "40px",
              height: "40px",
              backgroundColor: "#e5e7eb",
              borderRadius: "8px",
              animation: "pulse 1.5s ease-in-out infinite",
              animationDelay: "0.2s",
            }}
          />
          <div
            style={{
              width: "80px",
              height: "40px",
              backgroundColor: "#e5e7eb",
              borderRadius: "8px",
              animation: "pulse 1.5s ease-in-out infinite",
              animationDelay: "0.3s",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TableSkeleton;